module.exports = {
    "AGE_BAND": {
        "internalFieldName": "AGE_BAND",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "include_uncoded_records": {"value": "spaces", "label": "Include Uncoded Records", "type": "Checkbox"},
        "targetType": "rangeType",
        "labelForUser": "Age Range",
        "values": {
            "low": [18, 21, 26, 31, 36, 41, 46, 51, 56, 61, 66, 71, 76],
            "high": [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 100]
        },
        "prefix": ""
    },
    "EST_INCOME_NARROW_RANGE": {
        "internalFieldName": "EST_INCOME_NARROW_RANGE",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "include_uncoded_records": {"value": "spaces", "label": "Include Uncoded Records", "type": "Checkbox"},
        "targetType": "rangeType",
        "labelForUser": "Income Range",
        "values": {
            "low": [0, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 125000, 150000, 175000, 200000, 250000],
            "high": [14999, 19999, 29999, 39999, 49999, 74999, 99999, 124999, 149999, 174999, 199999, 249999, 1000000]
        },
        "prefix": "$ "
    },
    // "GENDER_CODE": {
    //     "internalFieldName": "GENDER_CODE",
    //     "dataSource": "DEMOGRAPHICS CONSUMER",
    //     "targetType": "andType",
    //     "labelForUser": "Gender",
    //     "values": {"M": "Male", "F": "Female"},
    //     "prefix": ""
    // },
    // "DWELLING_UNIT_SIZE": {
    //     "internalFieldName": "DWELLING_UNIT_SIZE",
    //     "dataSource": "DEMOGRAPHICS CONSUMER",
    //     "targetType": "andType",
    //     "labelForUser": "Number of Families Per Unit",
    //     "values": {"1": "Include Unincoded Records", "2": "Single Family Unit", "3": "Multiple Family Unit"},
    //     "prefix": ""
    // },
    "HOME_MARKET_VALUE": {
        "internalFieldName": "HOME_MARKET_VALUE",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "targetType": "rangeType",
        "labelForUser": "Residence Value",
        "values": {
            "low": [1, 50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 575000, 650000, 725000, 800000, 900000, 1000000, 20000000],
            "high": [49999, 99999, 149999, 199999, 249999, 299999, 349999, 399999, 449999, 499999, 574999, 649999, 724999, 799999, 899999, 999999, 1999999, 99999999999]
        },
        "prefix": "$ "
    },
    "PR_NETWORTH": {
        "internalFieldName": "PR_NETWORTH",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "targetType": "rangeType",
        "labelForUser": "Networth",
        "values": {
            "low": [0, 25000, 50000, 75000, 100000, 150000, 250000, 500000, 750000, 1000000],
            "high": [24999, 49999, 74999, 99999, 149999, 249999, 499999, 749999, 999999, 9999999]
        },
        "prefix": "$ "
    },
    "OWNER_RENTER_FLAG": {
        "internalFieldName": "OWNER_RENTER_FLAG",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "targetType": "andType",
        "labelForUser": "Owner or Renter",
        "values": {"1": "Owner", "2": "Renter", "spaces": "Include Uncoded Records"},
        "prefix": ""
    },
    "LENGTH_RESIDENCE": {
        "internalFieldName": "LENGTH_RESIDENCE",
        "dataSource": "DEMOGRAPHICS CONSUMER",
        "targetType": "rangeType",
        "labelForUser": "Length of Residence",
        "values": {"low": [0, 0.6, 1, 3, 6, 11, 16, 21], "high": [0.5, 0.99, 2, 5, 10, 15, 20, 1000]},
        "prefix": ""
    },

    "SIC1_2_ARRAY": {
        "internalFieldName": "SIC1_2_ARRAY",
        "dataSource": "DEMOGRAPHICS BUSINESS",
        "targetType": "treeType",
        "labelForUser": "SIC Codes",
        "values": [
            {
                "code": "2361",
                "description": "Girls' & Children's Dresses, Blouses & Shirts",
                "children": {
                    "236100": {
                        "code": "236100",
                        "description": "Girls' & Children's Dresses, Blouses & Shirts",
                        "children": {
                            "23610000": {
                                "code": "23610000",
                                "description": "Girl's And Children's Dresses, Blouses"
                            }
                        }
                    },
                    "236101": {
                        "code": "236101",
                        "description": "Girls' And Children's Blouses And Shirts",
                        "children": {
                            "23610100": {
                                "code": "23610100",
                                "description": "Girls' And Children's Blouses And Shirts"
                            },
                            "23610101": {
                                "code": "23610101",
                                "description": "Blouses: Girls', Children's, And Infants'"
                            },
                            "23610102": {
                                "code": "23610102",
                                "description": "Shirts: Girls', Children's, And Infants'"
                            },
                            "23610103": {
                                "code": "23610103",
                                "description": "T-Shirts And Tops: Girls', Children's, And Infants'"
                            }
                        }
                    },
                    "236199": {
                        "code": "236199",
                        "description": "Girl's And Children's Dresses, Blouses, Nec",
                        "children": {
                            "23619901": {
                                "code": "23619901",
                                "description": "Dresses: Girls', Children's, And Infants'"
                            }
                        }
                    }
                }
            },
            {
                "code": "01",
                "description": "Agricultural Production - Crops",
                "children": {
                    "0111": {
                        "code": "0111",
                        "description": "Wheat",
                    },
                }
            },

            {
                "code": "02",
                "description": "Agricultural Production Livestock",
            },
        ],
    }
};